import React from 'react';

import { ScreenLink } from '@gogame/screens';

import { smartRulesTrackerRedirectLink } from 'scenes/SmartRules/navigation';

export const LogLinkToTracker = ({
  children,
  logId,
  affectedDimension,
  affectedSecondaryDimension,
}) => {
  return (
    <ScreenLink
      link={smartRulesTrackerRedirectLink}
      params={{
        id: logId || 0,
        affectedDimension,
        affectedSecondaryDimension,
      }}
      target={'_blank'}
    >
      {children}
    </ScreenLink>
  );
};
